// Desktop:
// Opens on the button (actually container) hover
// Mobile:
// Opens on the button click

const paddingTopValue = 20;
const paddingBottomValue = 20;
const paddingLeftValue = 20;
const paddingRightValue = 20;

class LookBookCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cardInner = this.querySelector('#card-inner');
    this.button = this.querySelector('#card-look-button');
    this.contentWrapper = this.querySelector('#card-look-content-wrapper');
    this.content = this.querySelector('#card-look-content');

    this.button.addEventListener('click', () => {
      if (window.innerWidth <= 989) {
        this.openProductsList()
      }
    })
    this.contentWrapper.addEventListener('mouseenter', () => {
      if (window.innerWidth >= 990) {
        this.openProductsList();
      }
    })

    this.cardInner.addEventListener('click', (e) => {
      if (window.innerWidth <= 989) {
        if (
          e.target.id !== 'card-look-button' &&
          e.target.id !== 'card-look-content' &&
          e.target.id !== 'card__look-item'
        ) {
          this.closeProductsList();
        }
      }
    })

    this.contentWrapper.addEventListener('mouseleave', () => {
      if (window.innerWidth >= 990) {
        this.closeProductsList();
      }
    })
  }

  openProductsList = () => {
    this.button.classList.add('hidden');
    this.contentWrapper.classList.add('card__look-content-wrapper--active');

    this.contentWrapper.style.height = `${this.content.scrollHeight}px`;
    this.contentWrapper.style.maxHeight = `${this.cardInner.offsetHeight * 0.8 - paddingTopValue - paddingBottomValue}px`;

    if (window.innerWidth <= 989) {
      this.contentWrapper.style.width = `calc(100% - ${paddingLeftValue + paddingRightValue}px)`;
    } else {
      this.contentWrapper.style.width = `${this.content.offsetWidth + paddingLeftValue + paddingRightValue}px`;
    }

    this.content.classList.remove('card__look-content--hidden');
    this.content.removeAttribute('aria-hidden');
  }

  closeProductsList = () => {
    this.button.classList.remove('hidden');
    this.contentWrapper.classList.remove('card__look-content-wrapper--active');
    this.contentWrapper.style.height = "";
    this.contentWrapper.style.width = "";
    this.content.classList.add('card__look-content--hidden');
    this.content.setAttribute('aria-hidden', 'true');
  }
}

customElements.define('look-book-card', LookBookCard);